export default defineNuxtRouteMiddleware(async () => {
  const client = useClient()
  const localePath = useLocalePath()

  if (!client.value) {
    return navigateTo(localePath('/sign-in'), { replace: true })
  }
})
